import { object, string, number } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

const DEFAULT_MAX_POINTS_VALUE = 2000000;

const getSchema = (maxPointsValue: number) =>
  object({
    points: number({ required_error: IS_REQUIRED })
      .int()
      .min(0)
      .max(maxPointsValue, 'Adjustment exceeds the maximum allowed points'),
    mathematicalFunction: string({ required_error: IS_REQUIRED }),
    adjustmentReasonId: string().nullable().default(null),
    notes: string().nullable().optional(),
  });

export const getUpdatePointsValidation = (maxPointsValue: number | null) => {
  // Int 32
  const schema = getSchema(maxPointsValue || DEFAULT_MAX_POINTS_VALUE);
  return makeValidate(schema);
};
